
export function formDataToQueryString(data) {
    return [...data.entries()]
        .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
        .join('&');
}

export function serializeForm(form) {
    // Setup our serialized data
    var serialized = {};

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];
        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
        
        // Convert field data to a query string
        if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized[field.name] = field.value;
        }
    }

    return serialized;
}

export function objectToFormData(obj)
{
    const data = new FormData();
    if ((typeof obj === 'object') && (obj !== null)) {
        for(let key in obj) {
            let value = obj[key];
            if (Array.isArray(value)) {
                value.forEach(val => data.append(`${key}[]`, val));
            } else {
                data.append(key, value);
            }
        }
    }
    return data;
}


/**
 * Fügt die Klasse 'touched' zu allen Inputs hinzu sobal diese das erste mal den Fokus erhalten haben.
 * 
 * @param {HTMLNode} node 
 */
function _formInputTouchedWatcher(node) {
    if ('querySelectorAll' in node) {
        node.querySelectorAll('input, textarea, select')
            .forEach(element => element.addEventListener(
                'focus',
                function () {
                    element.classList.add('touched');
                },
                { once: true }
            ));
    }
}

/**
 * Bindet Event-Listener auf alle Form-Elements
 */
export function initInteractiveForms() {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes) {
                mutation.addedNodes.forEach(node => _formInputTouchedWatcher(node))
            }
        });
    });
    observer.observe(document.body, {
        attributes: false,
        childList: true,
        characterData: false
    });
    _formInputTouchedWatcher(document.body);
}